import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState,} from "react";
import {useTranslation} from "react-i18next";
import {IClusterPlanLongItem, IGetPlanLongAPIParam,} from "../../../api/apiTypes";
import {queries} from "../../../api/queries";
import styles from "./plan.module.css";
import {useDataAll} from "../../../api/useDataAll";
import {getKeyFromDataGetSelectedData} from "../../../common/fns";
import {CustomTable} from "../../molecules/CustomTable";

type Props = {
  params: IGetPlanLongAPIParam;
  onSelectData: (data: IClusterPlanLongItem[]) => void;
};

const PlanTable = forwardRef(({params, onSelectData}: Props, ref) => {
  const {t} = useTranslation(["shipping"]);
  const shouldSelectAll = useRef(false);
  const prevClusters = useRef<string[]>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  
  const {
          listData, mutate, isLoading
        } = useDataAll<IClusterPlanLongItem>(queries.plan.long, params, 1000, {
    initialSize: 1, revalidateOnFocus: false
  });
  
  useImperativeHandle(ref, () => ({
    requestRefresh: () => {
      mutate()
      shouldSelectAll.current = false;
    }
  }), [mutate]);
  
  useEffect(() => {
    shouldSelectAll.current = !!params.cluster_id_startswith_in_csv?.length && prevClusters.current?.length !== params.cluster_id_startswith_in_csv?.length
    prevClusters.current = params.cluster_id_startswith_in_csv;
  }, [params]);
  
  useEffect(() => {
    console.log("plantable1", listData.length, shouldSelectAll.current);
    if (listData) {
      setSelectedRowKeys(prevKeys => {
        const {selectedData, keys} = getKeyFromDataGetSelectedData(listData, "id", prevKeys);
        console.log("plantable2", shouldSelectAll.current, "selectedData", selectedData, "keys", keys, "prevkey: ", prevKeys);
        if (shouldSelectAll.current) {
          onSelectData(listData);
          return keys;
        }
        onSelectData(selectedData);
        return prevKeys;
      })
    }
  }, [listData]);
  
  const columns = [
    {
      title: t("cluster id"),
      render: (text: string, p: IClusterPlanLongItem) => (
        <span className={styles.planCluster + " " + styles.planCell}>{p.cluster_id || "-"}</span>),
    }, {
      title: t("bunny type"), width: 80, render: (text: string, p: IClusterPlanLongItem) => {
        const bunnyColor = String(p.bunny_color)
        .toUpperCase();
        return (<span className={styles.bunnyType + " " + styles[bunnyColor]}>
              {bunnyColor || "-"}
            </span>);
      },
    }, {
      title: t("chute id"), width: 70, render: (text: string, p: IClusterPlanLongItem) => p?.chute_id,
    }, {
      title: t("shipping count"),
      width: 80,
      render: (text: string, p: IClusterPlanLongItem) => `${p?.count_scanned_all} / ${p?.shipping_item_count}`,
    }
  ];
  
  const handleChangeRow = useCallback((keys: any[], rows: IClusterPlanLongItem[]) => {
    setSelectedRowKeys(keys);
    onSelectData(rows);
  }, [onSelectData]);
  
  return (<CustomTable<IClusterPlanLongItem>
    size={"small"}
    columns={columns}
    dataSource={listData}
    rootClassName={"plan-table"}
    rowSelection={{onChange: handleChangeRow, selectedRowKeys}}
    rowKey={"id"}
    scroll={{y: 'calc(100vh - (302px + 40px + 48px + 80px))'}}
    pagination={false}
    loading={isLoading}
  />);
});

export default PlanTable;
